"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/APIKeys/components/apiKeyColumns.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _time = require('shared/services/time');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);


var _OrgPills = require('../../People/OrgPills'); var _OrgPills2 = _interopRequireDefault(_OrgPills);
var _APIKeyMenu = require('./APIKeyMenu'); var _APIKeyMenu2 = _interopRequireDefault(_APIKeyMenu);
var _helpers = require('../helpers');









// The Expires column: when it ended for revoked and expired keys, when it
// ends otherwise, or Never.
const ExpiryCell = ({ apiKey: k }) => {
  const soon = _helpers.getExpiringSoonLabel.call(void 0, k)
  if (k.Status === 'revoked') return _react2.default.createElement(_react2.default.Fragment, null, "Revoked " ,  _time.formatShortDisplayDate.call(void 0, k.RevokedAt) )
  if (!k.ExpiresAt) return _react2.default.createElement('span', { className: "settings--org-api-keys--never-expires", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}, "Never")
  const date = _time.formatShortDisplayDate.call(void 0, k.ExpiresAt)
  return (
    _react2.default.createElement('div', { className: "settings--org-api-keys--cell-stack", __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}
      , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 29}},  k.Status === 'expired' ? `Expired ${date}` : date )
      ,  soon && _react2.default.createElement('span', { className: "settings--org-api-keys--expiring-soon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}},  soon ) 
    )
  )
}

/* Account → API keys as a table (F-15), the People table's pattern: the
 * name with its key prefix under it (as People puts the email under the
 * name), one pill and "+N" for orgs and scopes, the status in its own
 * column, and a ⋯ menu at the right end (F-17). Sized to fit the settings
 * pane at a laptop width. */
 const apiKeyColumns = ({ orgName, defaultOrgKey, onChangeExpiry, onRevoke }) => [
  {
    id: 'name',
    label: 'Name',
    // The rest of the width.
    cell: k => (
      _react2.default.createElement('div', { className: "settings--org-api-keys--who", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}
        , _react2.default.createElement('span', { className: "settings--org-api-keys--name-text", title: k.Name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}},  k.Name )
        , _react2.default.createElement('code', { className: "settings--org-api-keys--prefix", title: k.Prefix, __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}},  k.Prefix )
      )
    ),
  },
  {
    id: 'orgs',
    label: 'Organizations',
    width: 160,
    cell: k => _optionalChain([k, 'access', _ => _.Orgs, 'optionalAccess', _2 => _2.length])
      ? _react2.default.createElement(_OrgPills2.default, { names: _OrgPills.orderOrgNames.call(void 0, k.Orgs, orgName, defaultOrgKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}} )
      : 'All',
  },
  { id: 'scopes', label: 'Scopes', width: 150, cell: k => _react2.default.createElement(_OrgPills2.default, { names: k.Scopes, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}} ) },
  { id: 'created', label: 'Created', width: 70, cell: k => _time.formatShortDisplayDate.call(void 0, k.CreatedAt) },
  {
    id: 'lastUsed',
    label: 'Last used',
    width: 78,
    cell: k => k.LastUsedAt
      ? _time.formatShortDisplayDate.call(void 0, k.LastUsedAt)
      : _react2.default.createElement('span', { className: "settings--org-api-keys--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}, "Never"),
  },
  { id: 'expires', label: 'Expires', width: 115, cell: k => _react2.default.createElement(ExpiryCell, { apiKey: k, __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}} ) },
  {
    id: 'status',
    label: 'Status',
    width: 80,
    cell: k => (
      _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 'settings--org-members--member-badge', `settings--org-api-keys--status--${k.Status}`), __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}
        ,  _helpers.STATUS_LABELS[k.Status] 
      )
    ),
  },
  {
    id: 'actions',
    label: '',
    width: 52,
    className: 'settings--org-api-keys--actions',
    // Revoked keys are final: no menu.
    cell: k => _helpers.canManageKey.call(void 0, k) && _react2.default.createElement(_APIKeyMenu2.default, { apiKey: k, onChangeExpiry: onChangeExpiry, onRevoke: onRevoke, __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}} ),
  },
]; exports.apiKeyColumns = apiKeyColumns
